import React from 'react'

const ChargeCustomer = () => {
  return (
    <div>ChargeCustomer</div>
  )
}

export default ChargeCustomer